var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.item.interactor)?[_c('span',{staticClass:"my-2 tw-text-gray"},[_vm._v("N/A")])]:[_c('v-chip',_vm._g({staticClass:"my-2 tw-text-white",attrs:{"label":"","small":"","outlined":"","color":"info"}},_vm.on),[_vm._v(" "+_vm._s(_vm.item.interactor.name)+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }